module.exports = __webpack_public_path__ + "static/images/AppQRCode.6571c3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/AppQRCode.png
// module id = uaa6
// module chunks = 0